/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementCategoryItemResponse } from './StoreManagementCategoryItemResponse';

export type StoreManagementCategoryItemResponseApiRespoonse = {
    data?: StoreManagementCategoryItemResponse;
    status?: StoreManagementCategoryItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementCategoryItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

